package math

import kotlin.math.pow

fun easeInOutQuad(x: Double): Double {
    return if(x < 0.5) 2.0 * x * x else 1.0 - ((-2.0*x+2.0).pow(2.0)/2.0)
}
